import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'tabs/tab1',
    children: [
      {
        path: '',
        loadChildren: './tab1/tab1.module#Tab1PageModule'
      }
    ]
  },
  {
    path: 'tabs/tab2',
    children: [
      {
        path: '',
        loadChildren: './tab2/tab2.module#Tab2PageModule'
      }
    ]
  },
  {
    path: 'tabs/tab3',
    children: [
      {
        path: '',
        loadChildren: './tab3/tab3.module#Tab3PageModule'
      }
    ]
  },
  {
    path: '',
    redirectTo: '/tabs/tab1',
    pathMatch: 'full'
  },
  { path: 'guidance', loadChildren: './guidance/guidance.module#GuidancePageModule' },
  { path: 'price-plan', loadChildren: './price-plan/price-plan.module#PricePlanPageModule' },
  { path: 'support', loadChildren: './support/support.module#SupportPageModule' },
  { path: 'faq', loadChildren: './faq/faq.module#FaqPageModule' },
  { path: 'login', loadChildren: './login/login.module#LoginPageModule' },
  { path: 'signup', loadChildren: './signup/signup.module#SignupPageModule' },
  { path: 'terms', loadChildren: './terms/terms.module#TermsPageModule' },
  { path: 'yakkan', loadChildren: './yakkan/yakkan.module#YakkanPageModule' },
  { path: 'company', loadChildren: './company/company.module#CompanyPageModule' },
  { path: 'troubleguide', loadChildren: './troubleguide/troubleguide.module#TroubleguidePageModule' },
  { path: 'guidance-frame', loadChildren: './guidance-frame/guidance-frame.module#GuidanceFramePageModule' },
  { path: 'price-plan-frame', loadChildren: './price-plan-frame/price-plan-frame.module#PricePlanFramePageModule' },
  { path: 'faq-frame', loadChildren: './faq-frame/faq-frame.module#FaqFramePageModule' },
  { path: 'support-frame', loadChildren: './support-frame/support-frame.module#SupportFramePageModule' },
  { path: 'whatsnew', loadChildren: './whatsnew/whatsnew.module#WhatsnewPageModule' },
  { path: 'whatsnew-frame', loadChildren: './whatsnew-frame/whatsnew-frame.module#WhatsnewFramePageModule' }

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
